import React from "react";
import SectionsForm from "./SectionsForm";

const SectionsCreate = () => {
  return <SectionsForm />;
};

export default SectionsCreate;